import React from "react";
import { useTranslation } from "react-i18next";
import { Chip, StatusGlyph } from "@outpave/ds";
import WebhookEndpointStatus from "enums/WebhookEndpointStatus";
import {
  webhookEndpointStatusLabelKey,
  webhookEndpointStatusTone,
} from "utils/webhooks/webhookEndpoints";

interface WebhookEndpointStatusChipProps {
  status: WebhookEndpointStatus;
}

const WebhookEndpointStatusChip: React.FC<WebhookEndpointStatusChipProps> = ({
  status,
}) => {
  const { t } = useTranslation();
  const labelKey = webhookEndpointStatusLabelKey(status);
  const tone = webhookEndpointStatusTone(status);

  // StatusGlyph matches the untranslated label, so the glyph holds in every locale.
  return (
    <Chip
      tone={tone}
      size="sm"
      leading={<StatusGlyph status={labelKey} tone={tone} />}
    >
      {t(labelKey)}
    </Chip>
  );
};

export default WebhookEndpointStatusChip;
